// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function TrophyIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M29 8h-3V7a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v1H3a2 2 0 0 0-2 2v2a5 5 0 0 0 5 5h.456A10.016 10.016 0 0 0 15 23.951V27h-3a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2h-3v-3.052c3.992-.404 7.305-3.206 8.51-6.948H26a5 5 0 0 0 5-5v-2a2 2 0 0 0-2-2ZM6 15a3 3 0 0 1-3-3v-2h3v4c0 .333.016.667.049 1H6Zm18-1.113c0 4.44-3.561 8.08-7.939 8.113H16a8 8 0 0 1-8-8V7h16v6.887ZM29 12a3 3 0 0 1-3 3h-.063c.041-.37.062-.74.063-1.113V10h3v2Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
